import React, { forwardRef } from 'react';
import { InputGroup } from 'react-bootstrap';
import { CalendarWeek } from 'react-bootstrap-icons';
import moment from 'moment';
import { convertStringToDutchString } from '../../../../Helpers/Date';

const getDate = (value: string): string | undefined => {
    value = value.replace(/[-.,\\]/, '/');

    if (
        !moment(value as string, 'DD/MM/YYYY', 'nl', true).isValid()
        && moment(value as string, 'MM/DD/YYYY', 'nl', true).isValid()
    ) {
        return convertStringToDutchString(value as string);
    }

    return value;
}

// eslint-disable-next-line react/prop-types,react/display-name,@typescript-eslint/explicit-function-return-type
const CustomDateField = forwardRef(({ value, ...rest }: React.HTMLProps<HTMLInputElement>, ref: React.Ref<HTMLInputElement>) => {
    const date = getDate(value as string);

    return (
        <InputGroup ref={ref} className={'mb-1'}>
            <InputGroup.Prepend>
                <InputGroup.Text>
                    <CalendarWeek />
                </InputGroup.Text>
            </InputGroup.Prepend>
            <input value={date} {...rest} />
        </InputGroup>
    );
});

export default CustomDateField;
